import React from 'react';
import PropTypes from 'prop-types';
import Button from '../buttons/Button';

const types = ['boxes', 'list', 'thumbnail'];
const defaultType = types[0];

const splitOptions = {
  developer: ['admin', 'all_subteams', 'api_key_management'],
  editor: ['view_charts', 'create_chart', 'duplicate_chart', 'publish', 'edit_chart_meta', 'chart_trash'],
  customize: ['theme_management', 'customise_editor'],
  users: ['team_management', 'subteam_management', 'view_users']
};

const CheckboxGroup = ({ options, checked, onSelect, valueKey = 'value', extraClass = '', type = defaultType }) => {
  if (types.indexOf(type) < 0) {
    type = defaultType;
  }

  if (extraClass && extraClass.length) {
    extraClass = ' ' + extraClass;
  }

  if (type === 'thumbnail') {
    const keys = Object.keys(splitOptions);
    options.forEach((option) => {
      keys.forEach((key) => {
        if (splitOptions[key].includes(option.name)) {
          splitOptions[key][splitOptions[key].indexOf(option.name)] = option;
        }
      });
    });
  }

  return (
    <ul className={'checkbox-group checkbox-' + type + ' ' + extraClass}>
      {type === 'thumbnail' &&
        Object.keys(splitOptions).map((key, index) => {
          const onSelectAll = () => {
            splitOptions[key].forEach((option) => {
              onSelect(option[valueKey], true);
            });
          };

          const onDeselectAll = () => {
            splitOptions[key].forEach((option) => {
              onSelect(option[valueKey], false);
            });
          };

          return (
            <div key={index} className="thumbnail-container">
              <div className="thumbnail-container-header">
                <span className="thumbnail-container-header-text">{key}</span>
                <div className="buttons-container">
                  <Button buttonText="Choose all" buttonClass="bulk-action-btn secondary-btn" onClick={onSelectAll} />
                  <Button
                    buttonText="Clear"
                    buttonClass="bulk-action-btn secondary-btn negative"
                    onClick={onDeselectAll}
                  />
                </div>
              </div>

              {splitOptions[key].map((option, i) => {
                let value = option[valueKey];

                let active = checked.indexOf(value) >= 0;

                const onClick = () => {
                  active = !active;
                  onSelect(value, active);
                };

                return (
                  <div key={i} className="checkbox-container">
                    <div onClick={onClick} className={'thumbnail checkbox-div ' + (active ? 'active' : '')}>
                      <div className="caption">
                        <div className="checkbox-div-text checkbox-div-header">{option.title}</div>
                        <div className="checkbox-div-text checkbox-div-desc">{option.description}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
    </ul>
  );
};

CheckboxGroup.propTypes = {
  options: PropTypes.array.isRequired,
  checked: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  labelRenderer: PropTypes.func.isRequired,
  valueKey: PropTypes.string,
  extraClass: PropTypes.string,
  type: PropTypes.string
};

export default CheckboxGroup;
